// src/app/slices/jboxSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { IJbox, IJboxParams, AccessoryState } from '../models';

const initialState: AccessoryState<IJbox, IJboxParams> = {
  accessories: {},
  params: null,
};

const jboxSlice = createSlice({
  name: 'jbox',
  initialState,
  reducers: {
    setJbox: (state, action: PayloadAction<IJbox>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setJboxParams: (state, action: PayloadAction<IJboxParams>) => {
      state.params = action.payload;
    },
    deleteJbox: deleteAccessory,
  },
});

export const { setJbox, setJboxParams, deleteJbox } = jboxSlice.actions;

export default jboxSlice.reducer;
